<script>
import FbControll from "./FbControll";
import Comment from "../Comment";
export default {
  props: ["element", "nid", "sid", "main_sid", "isDraft", "index", 'validationFails'],
  data() {
    return {
      showDialog: false,
      collapse: false,
      saveData: {},
      tempData: {},
      list: []
    };
  },
  components: {
    FbControll,
    Comment
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": false
      };
    },
    valid() {
      return true;
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: this.saveData.value,
          type: this.element.type
        };
      }
      return undefined;
    }
  },
  created() {
    this.$emit("validation", this.valid);
    // const urlParams = new URLSearchParams(window.location.search);
    // let back_hash = urlParams.get('back_hash');
    // if (this.element.uuid == back_hash) {
    //   // TODO: Activate all steps...
    // }
  },
  methods: {
    token_replace(value, nid) {
      return this.$options.filters.token_replace(value, nid);
    },
    showSettings() {
      this.showDialog = true;
      this.resetData();
    },
    collapsePreview() {
      this.collapse = !this.collapse;
    },
    save() {
      this.showDialog = false;
      this.saveData = JSON.parse(JSON.stringify(this.tempData));

      this.$emit("save-data", { data: this.saveData, list: this.list });
    },
    cancel() {
      this.showDialog = false;
      this.resetData();
    },
    resetData() {
      this.tempData = JSON.parse(JSON.stringify(this.saveData));
    }
  },
  watch: {
    isDraft(newVal) {
      if(!newVal) {
        this.$emit("validation", this.valid);
      }
    }
  }
};
</script>
